import React from 'react';

const StudentCard = ({ student, isSelected, onClick }) => {
  // Parse target subjects to display as badges
  const subjects = student.target_subjects
    ? student.target_subjects.split(',').map(s => s.trim()).slice(0, 3)
    : [];

  return (
    <div
      className={`student-card ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => e.key === 'Enter' && onClick()}
    >
      <div className="student-card-header">
        {student.profile_image && (
          <img
            src={student.profile_image}
            alt="Student"
            className="student-avatar"
          />
        )}
        {!student.profile_image && (
          <div className="student-avatar-placeholder">
            <span>{student.owner?.charAt(0)?.toUpperCase() || '?'}</span>
          </div>
        )}
        <div className="student-info">
          <h3 className="student-name">Student {student.uuid.substring(0, 8)}</h3>
          <p className="student-grade">{student.grade_year_level}</p>
        </div>
      </div>

      <div className="student-card-body">
        {student.current_gpa && (
          <div className="student-stat">
            <span className="stat-label">GPA:</span>
            <span className="stat-value">{student.current_gpa}</span>
          </div>
        )}

        {subjects.length > 0 && (
          <div className="student-subjects">
            {subjects.map((subject, idx) => (
              <span key={idx} className="subject-badge">{subject}</span>
            ))}
            {student.target_subjects.split(',').length > 3 && (
              <span className="subject-badge more">+{student.target_subjects.split(',').length - 3}</span>
            )}
          </div>
        )}

        {student.learning_style && (
          <div className="student-detail">
            <small>Learning Style: {student.learning_style}</small>
          </div>
        )}
      </div>

      {isSelected && (
        <div className="selected-indicator">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="10" fill="#10b981"/>
            <path d="M6 10l3 3 5-6" stroke="white" strokeWidth="2" fill="none"/>
          </svg>
        </div>
      )}
    </div>
  );
};

export default StudentCard;
